<template>
      
    <div class="container">
        <div class="row">
            <div class="col-sm-12 col-md-4 col-lg-2">
                <SideMenu />
            </div>
            <div class="col-sm-12 col-md-12 col-lg-7">
                <section class="withdraw-deposit-btns mt-1" v-if="($siteSettings?.data && $siteSettings?.data?.business_type == 2) && ($auth.status)">
                    <div class="w-d-main">
                        <div class="wd-main-buttons">
                            <router-link :to="{ name: 'wallet-withdraw' }" class="btn-primary withdraw-btn">
                                <img loading="lazy"
                                    src="@/assets/images/wallet-icon.webp" alt="walletW">{{$t('withdrawal','Withdraw')}}
                            </router-link>
                            <router-link :to="{ name: 'wallet-deposit' }" class="btn-primary deposit-btn">
                                <img loading="lazy" 
                                    src="@/assets/images/deposit-icon.webp" alt="walletW">{{$t('deposit','Deposit')}}
                            </router-link>
                            
                        </div>
                    </div>
                </section>
                <section class=" p-2" v-if="$siteSettings?.data && ($route.name=='Home' || $route.name=='sports' || $route.matched.some(route => route.components.default.name === 'GamesModule'))">
                    <section v-if="$siteSettings?.data && ($route.name=='Home' || $route.name=='sports' || $route.name=='Poolzone')" class="banner-section">
                        <Carousel :wrapAround="true" :breakpoints="breakpoints" :items-to-show="1" :autoplay="2500"
                            class="owl-carousel owl-theme">
                            <Slide key="1" v-if="isAffiliate">
                                <div class="item" @click="$router.push({name: $auth.status ? 'AffDashboard' : 'login'})">
                                    <div class="main-slider-img owl-item">
                                        <figure>
                                            <img src="@/assets/images/affiliate-banner.webp" class="rounded" alt="affiliate_banner" loading="lazy" />
                                        </figure>
                                    </div>
                                </div>
                            </Slide>
                            <Slide key="2" v-if="$siteSettings?.data?.business_type == 2">
                                <div class="item" @click="$router.push({name: 'Poolzone'})">
                                    <div class="main-slider-img owl-item">
                                        <figure>
                                            <Vue3Lottie :animationData="PoolLottie" :height="200" :width="200" />
                                        </figure>
                                    </div>
                                </div>
                            </Slide>
                            <Slide v-for="(poster,index) in sitePosters" :key="index + 2">
                                <div class="item">
                                    <div class="main-slider-img owl-item">
                                        <figure>
                                            <img :src="$siteSettings?.data?.aws_url + $siteSettings?.data?.storage_path.poster_path + poster?.image"
                                                :alt="poster?.image" /></figure>
                                    </div>
                                </div>
                            </Slide>
                        </Carousel>
                    </section>
                </section>
                <SportSelection />
                <div class="rit-side-content">
                    <div class="row">
                        <div class="col-sm-12 col-md-12 col-lg-12">
                            <section class="inplay-game-sec" v-if="allData?.inplay?.length > 0 ">
                                <div class="main-heading thm-header-title">
                                    <div class="heading-content">
                                        <h1><i class="fa-solid fa-circle-play"></i> {{$route.name == 'Poolzone' ? $t('pool-zone','Pool Zone') : $t('inplay','In Play')}}</h1>
                                    </div>
                                    <div class="open-bet-staus" v-if="$route.name != 'Poolzone'">
                                        <a href="Javascript:void(0);" @click="callOpenBet()">{{$t('open-bets','Open Bets')}} <span v-if="$auth.status">{{
                                            $auth.user?.bets_count ?? 0 }}</span></a>
                                    </div>
                                </div>
                                <div class="inplay-match-list">
                                    <div class="inplay-game-box" v-for="(sport, sIndex) in inplayMatches" :key="sIndex">
                                        <template v-if="sport.length > 0">
                                            <div class="inplay-item-heading">
                                                <h2>
                                                    <img  class="me-1" :src="getSportImage(sport[0]?.sport_id)" alt="sports-image">
                                                    <span class="text-capitalize">{{ sIndex == 'Soccer' ? $t('football','Football') : $t(sIndex.toLowerCase(),sIndex) }}</span>
                                                </h2>
                                                <div class="inplay-heading-title">
                                                    <ul>
                                                        <li>1</li>
                                                        <li>X</li>
                                                        <li>2</li>
                                                    </ul>
                                                    
                                                </div>
                                            </div>
                                            <SportItem :sportsData="sport" />
                                        </template>
                                    </div>
                                </div>
                            </section>

                            <div ref="gamesAndUpcomingSection"></div>
                            <template v-for="(section, index) in sectionWiseGamesList">
                                <section class="inplay-game-sec upcoming-events-sec" :key="index" v-if="section.games && section.games.length > 0 && isLoadOtherSections && $auth.user?.actw != 'WB'">
                                    <div class="main-heading">
                                        <div class="heading-content">
                                            <h1>
                                                <span><img :src="section.icon" alt="Icon"></span>
                                                {{ $t(section.translationKey, section.title) }}
                                            </h1>
                                        </div>
                                    </div>
                                    <GameItem :games="section.games" :gameClass="section.gameClass"></GameItem>
                                </section>
                            </template>

                            <section class="inplay-game-sec upcoming-events-sec" v-if="isLoadOtherSections && $route.name !='Poolzone'">
                                <div class="main-heading">
                                    <div class="heading-content">
                                        <h1><i class="fa-solid fa-circle-play"></i> {{$t('upcoming-events','Upcoming Events')}}</h1>
                                    </div>
                                </div>
                                <div class="inplay-match-list">
                                    <div class="inplay-game-box" v-for="(sport, sIndex) in upcomingMatches" :key="sIndex">
                                        <template v-if="sport.length > 0">
                                            <div class="inplay-item-heading">
                                                <h2>
                                                    <img  class="me-1" :src="getSportImage(sport[0]?.sport_id)" alt="sports-image">
                                                    <span class="text-capitalize">{{ sIndex == 'Soccer' ? $t('football','Football') : $t(sIndex.toLowerCase(),sIndex) }}</span>
                                                </h2>
                                                <div class="inplay-heading-title">
                                                    <ul>
                                                        <li>1</li>
                                                        <li>X</li>
                                                        <li>2</li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <SportItem :sportsData="sport" />
                                        </template>
                                    </div>
                                    <div v-if="upcomingMatches?.length==0">
                                        {{$t('no-real-records','No Real-Time Records Found')}}
                                    </div>
                                </div>
                            </section>

                        </div>

                    </div>
                </div>
                
            </div>
            <div class="col-sm-12 col-md-4 col-lg-3 md-display-none" v-if="!this.$helper.isMobile()">
                <AvailableCredit />
                <BetSlip />
            </div>
        </div>
    </div>
    <div class="modal fade stake-modal" id="depositModal" tabindex="-1" aria-labelledby="depositModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="deposit-wallet-modal">
                        <div class="wallet-modal-icon">
                            <img loading="lazy" src="@/assets/images/purse.webp">
                        </div>
                        <h4>{{$t('looks-like-your-balance-is-too-low','Looks like your balance is too low')}}</h4>
                        <p>{{$t('deposit-balance-to-continue-playing','Deposit balance to continue playing')}}</p>
                    </div>
                    <div class="deposit-btn-row">
                        <button type="button" class="btn cancel-btn" data-bs-dismiss="modal">{{$t('cancel','Cancel')}}</button>
                        <button type="button" class="btn deposit-btn">{{$t('deposit-balance','Deposit Balance')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div ref="open_loader_modal" data-bs-toggle="modal" data-bs-target="#betplace-modal" style="display:none"></div>

</template>

<script>
import { Carousel, Slide, Pagination } from 'vue3-carousel';
import { checkEventManageforSports, checkForLockedMatches, checkInEventMangeForSection } from '@/shared/services/eventLocks.js';
import { defineAsyncComponent } from 'vue';
import { mapGetters } from 'vuex';
import { Vue3Lottie } from 'vue3-lottie';
import PoolLottie from './services/pool-lottie.json'

export default {
    name: 'Home',
    props: ["key"],
    components: {
        Carousel,
        Slide,
        Pagination,
        Vue3Lottie,
        SportItem: defineAsyncComponent(() =>
            import('@/modules/sports/components/SportItem.vue')
        ),
        SideMenu: defineAsyncComponent(() =>
            import('@/shared/components/header/SideMenu.vue')
        ),
        AvailableCredit: defineAsyncComponent(() =>
            import('@/shared/components/available-credit/AvailableCredit.vue')
        ),
        BetSlip: defineAsyncComponent(() =>
            import('@/shared/components/bet-slip/BetSlip.vue')
        ),
        SportSelection: defineAsyncComponent(() =>
            import('@/shared/components/sport-selection/SportSelection.vue')
        ),
        IFrameModal: defineAsyncComponent(() =>
            import('@/modules/games/components/IFrameModal.vue')
        ),
        GameItem: defineAsyncComponent(() =>
            import('@/shared/components/games/GameItem.vue')
        ),
    },
    data() {
        return {
            PoolLottie,
            sectionsList: null,
            betCloseSetTimeOut: null,
            delayTimer: 0,
            openIframeModal: false,
            gameCodeList: [],
            codeList: ['sbe_aviator', 'ezg_lobby', 'KINGMAKER-LOBBY', 'RG-LIVELOBBY', 'evo_topcardlobby'],
            inplayMatches: {},
            upcomingMatches: {},
            allData: {},
            betDetails: null,
            favouriteGamesList: this.$store?.getters?.favouriteGames,
            showConfirmBet:false,
            breakpoints: {
                0: {
                    itemsToShow: 1,
                    snapAlign: 'start',
                },
                480: {
                    itemsToShow: 2,
                    snapAlign: 'start',
                },
                668: {
                    itemsToShow: 3,
                    snapAlign: 'start',
                }
            },
            observer: null,
            isLoadOtherSections: false

        }
    },
    mounted() {
        this.getCasinoGamesServiceCall();
        this.getInplayMatches();
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting && !this.isLoadOtherSections) {
                    this.observer.unobserve(entry.target);
                    this.getUpcomingMatches();
                    this.isLoadOtherSections = true;
                }
            });
        });                 
    },
    computed: {
        sitePosters() {
            if (this.$siteSettings.data && this.$siteSettings.data.poster && this.$siteSettings.data.poster.length) {                
                return this.$siteSettings.data.poster.filter(s => s.poster_type == 1);
            } else {
                return [];
            }
        },
        ...mapGetters(['getSportImage', 'gamesData', 'eventManage', 'bonusData']),
        sectionWiseGamesList(){
            return [
                {
                    games: this.gamesData['exchange-games']?.games,
                    icon: require('@/assets/images/exchange.webp'),
                    translationKey: 'exchange-games',
                    title: 'Exchange Games',
                    gameClass: null,
                },
                {
                    games: this.gamesData['populer-games']?.games,
                    icon: require('@/assets/images/play-cart.webp'),
                    translationKey: 'popular-games',
                    title: 'Popular Games',
                    gameClass: 'provider-game-list',
                },
                {
                    games: this.gamesData['casino-providers']?.games,
                    icon: require('@/assets/images/play-cart.webp'),
                    translationKey: 'casino-provider',
                    title: 'Casino Provider',
                    gameClass: null,
                },
            ]
        },
        isAffiliate() {
            return this.bonusData?.find(bd => bd?.bonusType == "affiliate bonus");
        }

    },
    methods: {
        getInplayMatches() {
            this.$store.dispatch('setGlobalLoader',true)
            let url = this.$route.name == 'Home'? 'INPLAY_MATCHES_LIST' : 'INPLAY_POOL_LIST';
                this.$apiCall('GET', url, null, 'sports', ).then(response => {
                this.$store.dispatch('setGlobalLoader',false)
                if (response && response.status == 200) {
                    if (response?.data?.status === 0) {
						this.$errorToast(response.data.debug[0]);
					} else {
                            this.allData = response.data.data;
                            if(this.$route.name == 'Poolzone') {
                                this.allData.inplay = response.data.data
                            } 
                            var inplayMatchList = this.$route.name == 'Poolzone' ? response.data.data : response.data.data.inplay
                            this.inplayMatches = this.setMatchAndEvents(inplayMatchList);
                            setTimeout(() => {
                                let targetElement = this.$refs.gamesAndUpcomingSection;
                                if (targetElement) {
                                    this.observer.observe(targetElement);
                                }
                            }, 2000);
                        }
                }
            }).catch(error => {
                this.$store.dispatch('setGlobalLoader',false)
                if (error) {
                }
            });
        },
        getUpcomingMatches() {
            this.$apiCall('get', 'GET_UPCOMING_SPORTS', null, 'sports', { day: 'upcoming' }).then(response => {
                if (response && response.status == 200) {
                    var upcomingMatchList = response.data.data.sort().reverse();
                    this.upcomingMatches = this.setMatchAndEvents(upcomingMatchList);
                }
            }).catch(error => {
                if (error) {
                    console.log("Error : ", error);
                }
            });
        },
        setMatchAndEvents(matchList) {
            try {
                let sportObj =  {
                        cricket : [],
                        football: [],
                        soccer : [],
                        tennis : []
                    };
                let lockedMatchIds = [];
                let lockedLeagueIds = [];
                if (this.$auth.status) {
                    lockedMatchIds = this.eventManage?.filter(item => item.type == 'match').map(mid => mid.type_id);
                    lockedLeagueIds = this.eventManage?.filter(item => item.type == 'league').map(lid => lid.type_id);
                };
                for (var i = 0; i < matchList.length; i++) {
                    if(checkEventManageforSports(matchList[i].sport_id) && checkForLockedMatches(matchList[i].matchId, matchList[i].league_id, lockedMatchIds, lockedLeagueIds)) {
                        if (this.$auth.status) {
                            matchList[i]['favourite'] = this.favouriteGamesList?.includes(parseInt(matchList[i].event_id)) || false;
                        };
                        if (matchList[i].sport_id == 4) {
                            sportObj.cricket.push(matchList[i])
                        } else if (matchList[i].sport_id == 1) {
                            sportObj.soccer.push(matchList[i])
                        } else if (matchList[i].sport_id == 2) {
                            sportObj.tennis.push(matchList[i])
                        } else {
                            if(!sportObj[matchList[i].sport_name]) {
                                sportObj[matchList[i].sport_name] = [];
                            };
                            sportObj[matchList[i].sport_name].push(matchList[i]);
                        }
                    }
                };
                sportObj.football = sportObj.soccer;
                delete sportObj.soccer;
                return sportObj;
            } catch (e) {
                console.log(e);
            }
        },
        getCasinoGamesServiceCall() {
            if (this.$auth.status) {
                checkInEventMangeForSection(this.gamesData)
                this.$store.dispatch('setGamesData', this.gamesData);
            }
        },
        callOpenBet() {
            if (this.$auth.status) {
                this.$router.push({ name: 'bets' })
            }
            else {
                this.$helper.openModal('#login-casino-btn')
            }
        },
    }
}

</script>
<style>
.available-credit-sec {
    margin-top: 0px;
    margin-bottom: 10px;
}
.main-slider-img .lottie-animation-container {
    width: 100%;
}
</style>